import React from "react";

const COLORS = {
  anger: "theme-anger",
  fear: "theme-fear",
  jealousy: "theme-jealousy",
  default: "theme-default",
};

export const themeClass = (token) => COLORS[token] || COLORS.default;

export function ThemeChip({ token, children, className = "" }) {
  return (
    <span className={`chip ${themeClass(token)} theme-surface theme-text ${className}`}>
      {children}
    </span>
  );
}
